export const requiredRule = (prop: string) => {
    const {t} = useI18n()
    return v => !!v || v === 0 || `${prop ? `${t(prop)} ` : ''}${t('validation.required')}`
}

export const requiredArrayRule = (prop: string) => {
    const {t} = useI18n()

    return v => {
        const message = `${t(prop)} ${t('validation.required')}`
        return Array.isArray(v) ? v.length > 0 || message : message
    }
}

export const timeFormatRule = () => {
    const {t} = useI18n()
    return v => {
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
        if (!v || regex.test(v)) {
            return true
        }
        return t('time_format_error')
    }
}

export const emailRule = (prop: string) => {
    const {t} = useI18n()
    return v => {
        if (!v) return true

        const basicEmailCheck = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v)
        const noForbiddenChars = !/[(),:;<>[\]\\]/.test(v)

        const isValid = basicEmailCheck && noForbiddenChars && !v.includes('http') && v.length <= 254

        return isValid || `${t(prop)} ${t('validation.valid')}`
    }
}

export const validationRules = (prop: any, ruleFns: any, fieldKey?: any, params?: any) => {
    return ruleFns.map(ruleFn => ruleFn(prop, fieldKey, params))
}

export const onlyInteger = (prop: string) => {
    const {t} = useI18n()
    return v => /^\d+$/.test(v) || `${t(prop)} ${t('validation.integer')}`
}

export const moreThanZero = (prop: string) => {
    const {t} = useI18n()
    return v => parseInt(v) >= 0 || `${t('validation.positiveNumber', {prop})}`
}

export const maxLength = (prop: number) => {
    const {t} = useI18n()
    return v => !v || v?.length <= prop || `${t('validation.max_characters', {prop})}`
}

export const quantityItems = (prop: number) => {
    const {t} = useI18n()
    return v => !v || v?.length === prop || `${t('validation.quantity', {prop})}`
}

export const maxIntervalRules = (minValue: number, validationText: string) => {
    if (!minValue) return
    return value => value >= minValue || validationText
}

export const minIntervalRules = (maxValue: number, validationText: string) => {
    if (!maxValue) return
    return value => value <= maxValue || validationText
}
